import media from './media'


const mediaProps = {
  mobile: {
    maxWidth: media.mobileEnd,
  },
  tablet: {
    minWidth: media.tabletPortraitStart,
    maxWidth: media.tabletLandscapeEnd,
  },
  desktop: {
    minWidth: media.desktopStart,
  },

  tabletPortrait: {
    minWidth: media.tabletPortraitStart,
    maxWidth: media.tabletPortraitEnd,
  },
  tabletLandscape: {
    minWidth: media.tabletLandscapeStart,
    maxWidth: media.tabletLandscapeEnd,
  },

  exceptMobile: {
    minWidth: media.tabletPortraitStart,
  },
  exceptDesktop: {
    maxWidth: media.desktopStart,
  },

  tabletLandscapeAndHigher: {
    minWidth: media.tabletLandscapeStart,
  },
  tabletLandscapeAndLower: {
    maxWidth: media.tabletLandscapeEnd,
  },

  tabletPortraitAndHigher: {
    minWidth: media.tabletPortraitStart,
  },
  tabletPortraitAndLower: {
    maxWidth: media.tabletPortraitEnd,
  },

  retina: {
    minResolution: '2dppx',
  },
}


export default mediaProps
